import { Component, OnInit } from '@angular/core';
import {RechercheModeleDto} from "@common/resources/resources";
import {ArianeElement, ArianeStore} from "@digicerba/common";

@Component({
  selector: 'app-dossier-bloques-modele',
  templateUrl: './dossier-bloques-modele.component.html',
})
export class DossierBloquesModeleComponent implements OnInit {

  rechercheModeleDto: RechercheModeleDto;

  constructor(private arianeStore: ArianeStore) {
  }

  ngOnInit() {
    let arianeElements: Array<ArianeElement>;

    arianeElements = [
      {
        libelle: "Dossiers bloqués",
        route: ""
      },
      {
        libelle: "Administration",
        route: "/admin"
      },
      {
        libelle: "Catalogue modèles",
        route: "/catalogue"
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  onFiltering(rechercheModeleDto: RechercheModeleDto){
    this.rechercheModeleDto = rechercheModeleDto;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/dossier-bloques-modele/dossier-bloques-modele.component.ts